import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthServiceService } from '../services/auth-service.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {

  //Evento para informar qual item do menu esta selecionado
  @Output() selectedItem = new EventEmitter<string>();

  //Evento para informar que o menu esta aberto ou fechado
  @Output() menuStatus = new EventEmitter<boolean>();

  public menuSelected: string = "clientes";

  public menuUser: string = atob(localStorage.getItem('uL') ?? '');
  public isMobileMenuOpen: boolean = false;

  constructor(private router: Router, private authService : AuthServiceService) { }


  public async redirect(rota: string) {
    try {
      await this.router.navigate([rota]);
    } catch (error) {
      console.error('Erro ao redirecionar:', error);
    }
  }

  public itemSelected(item: string){
    this.menuSelected = item;
    this.selectedItem.emit(item);
    this.closeMobileMenu();
  }

  public menuOpen(){
    if (this.isMobileMenuOpen) return;
    this.menuStatus.emit(true);
  }

  public menuClose(){
    if (this.isMobileMenuOpen) return;
    this.menuStatus.emit(false);
  }

  public toggleMobileMenu(){
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    this.menuStatus.emit(this.isMobileMenuOpen);
  }

  public closeMobileMenu(){
    if (!this.isMobileMenuOpen) return;
    this.isMobileMenuOpen = false;
    this.menuStatus.emit(false);
  }

  public logout(){
    this.authService.logout();
  }
}
